const React = require('react');
const TransitionElement = require('components/shared/transition_element.jsx');

const PaymentMethodSelectLoadingPlaceholder = () =>
  <TransitionElement>
    <div className="loading-placeholder-content">
      <div className="bordered bd-rounded ptb-1 plr-1 mb-1">
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
        <div className="placeholder-li mb-1 mt-1"></div>
      </div>
    </div>
  </TransitionElement>;

module.exports = PaymentMethodSelectLoadingPlaceholder;



// WEBPACK FOOTER //
// ./javascripts/components/shop/payment_method_select_loading_placeholder.jsx